import { ArrowRight } from "lucide-react";
import metaPartner from "@/assets/partners/meta.svg";
import googlePartner from "@/assets/partners/google.svg";
import googleCloudPartner from "@/assets/partners/google-cloud.svg";
import shopifyPartner from "@/assets/partners/shopify.svg";
import tiktokPartner from "@/assets/partners/tiktok.svg";

const Hero = () => {
  return (
    <section className="relative lg:min-h-screen flex items-center pt-32 pb-12 overflow-hidden">
      {/* Purple haze gradient backdrop — pure CSS (no image) so it never blocks LCP */}
      <div
        aria-hidden
        className="absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 50% 30%, hsl(270 95% 75% / 0.35), transparent 60%), radial-gradient(ellipse 70% 50% at 20% 70%, hsl(280 90% 70% / 0.25), transparent 55%), radial-gradient(ellipse 70% 50% at 85% 75%, hsl(260 95% 75% / 0.28), transparent 55%), linear-gradient(180deg, hsl(0 0% 100%) 0%, hsl(0 0% 100% / 0.7) 60%, hsl(var(--background)) 100%)",
        }}
      />


      <div className="container relative z-10 px-6">
        <div className="max-w-5xl mx-auto text-center">
          {/* Headline */}
          <h1 className="font-display text-4xl md:text-6xl lg:text-[4.25rem] font-bold tracking-[-0.04em] text-foreground leading-[1.08] max-w-4xl mx-auto">
            La primera agencia de marketing
            <br />
            <span className="text-primary">que te escucha</span>
          </h1>


          {/* CTAs */}
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <button
              onClick={() => document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" })}
              className="group flex items-center justify-center gap-2 px-8 py-3.5 bg-foreground text-background rounded-full font-medium transition-all hover:bg-foreground/85 hover:shadow-xl hover:-translate-y-0.5 active:scale-95"
            >
              Ver servicios
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </button>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="group flex items-center justify-center gap-2 px-8 py-3.5 bg-primary text-primary-foreground rounded-full font-medium transition-all hover:bg-primary/90 hover:shadow-xl hover:-translate-y-0.5 active:scale-95 shadow-lg shadow-primary/20"
            >
              Agendar reunión
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </div>

        {/* Partners row */}
        <div className="mt-16 pt-10 border-t border-border/50">
          <p className="text-xs uppercase tracking-widest text-muted-foreground text-center mb-6 font-body">Partners oficiales</p>
          {(() => {
            const row1 = [
              { src: googlePartner, alt: "Google Partner" },
              { src: metaPartner, alt: "Meta Business Partner" },
              { src: googleCloudPartner, alt: "Google Cloud Partner" },
              { src: shopifyPartner, alt: "Shopify Partner" },
              { src: tiktokPartner, alt: "TikTok Marketing Partner" },
            ];
            return (
              <>
                {/* Desktop / tablet — static row */}
                <div className="hidden md:flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
                  {row1.map((p) => (
                    <img key={p.alt} src={p.src} alt={p.alt} width={140} height={48} loading="lazy" decoding="async" className="h-12 w-auto opacity-70 hover:opacity-100 transition-opacity grayscale hover:grayscale-0" />
                  ))}
                </div>

                {/* Mobile — infinite single-row marquee */}
                <div className="md:hidden overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]">
                  <div className="flex w-max animate-marquee-left gap-12 items-center">
                    {[...row1, ...row1].map((p, i) => (
                      <img key={`r1-${i}`} src={p.src} alt={p.alt} width={140} height={48} loading="lazy" decoding="async" className="h-12 w-auto opacity-80 grayscale shrink-0" />
                    ))}
                  </div>
                </div>
              </>
            );
          })()}
        </div>
      </div>
    </section>
  );
};

export default Hero;
